var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataMedicalRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6 35.5V23.6H70.025V35.5V37.1H71.625H73.4V74.4H56.35V65.875V64.275H54.75H41.25H39.65V65.875V74.4H22.6V37.1H48H49.6V35.5Z",
    stroke: "#222222",
    strokeWidth: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3633 30.5222V33.795H58.636V37.0677H61.9087V33.795H65.1815V30.5222H61.9087V27.2495H58.636V30.5222H55.3633Z",
    fill: "#6484F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 43,
    width: 6.54545,
    height: 6.54545,
    fill: "#6484F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5859,
    y: 43,
    width: 6.54545,
    height: 6.54545,
    fill: "#6484F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 53,
    width: 6.54545,
    height: 6.54545,
    fill: "#6484F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5859,
    y: 53,
    width: 6.54545,
    height: 6.54545,
    fill: "#6484F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5859,
    y: 43,
    width: 6.54545,
    height: 6.54545,
    fill: "#6484F1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5859,
    y: 43,
    width: 6.54545,
    height: 6.54545,
    fill: "#6484F1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5859,
    y: 53,
    width: 6.54545,
    height: 6.54545,
    fill: "#6484F1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5859,
    y: 53,
    width: 6.54545,
    height: 6.54545,
    fill: "#6484F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2164 58.274C76.3178 55.0244 71.6208 55.0277 69.7267 58.2798L57.3025 79.6125C55.3945 82.8887 57.7578 87 61.5491 87H86.4372C90.2315 87 92.5944 82.8827 90.6803 79.6066L78.2164 58.274Z",
    fill: "#6484F1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5859,
    y: 64,
    width: 4,
    height: 11.9998,
    rx: 1,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5859,
    y: 78.4001,
    width: 4,
    height: 3.59994,
    rx: 1,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataMedicalRecord);
export default __webpack_public_path__ + "static/media/data-medical-record.e9efccb805934ebec3e668050f072c09.svg";
export { ForwardRef as ReactComponent };